var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_9805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.012 12.1875H18.5721V7.50016C18.5721 3.36459 15.2436 0 11.1525 0C7.06136 0 3.73292 3.36459 3.73292 7.50016V12.1875H3.24602C1.45627 12.1875 0 13.6596 0 15.4688V26.7187C0 28.5279 1.45627 30 3.24602 30H19.012C20.8018 30 22.2581 28.5279 22.2581 26.7187V15.4688C22.2581 13.6596 20.8018 12.1875 19.012 12.1875ZM6.5155 7.50016C6.5155 4.91551 8.59561 2.8128 11.1525 2.8128C13.7094 2.8128 15.7895 4.91551 15.7895 7.50016V12.1875H6.5155V7.50016ZM19.4761 26.7187C19.4761 26.977 19.2682 27.1878 19.012 27.1878H3.24602C2.98989 27.1878 2.78194 26.977 2.78194 26.7187V15.4688C2.78194 15.2105 2.98989 14.9997 3.24602 14.9997H19.012C19.2682 14.9997 19.4761 15.2105 19.4761 15.4688V26.7187Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_9805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2581,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.29495e13.svg";
export { ForwardRef as ReactComponent };